import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {JsonPipe, NgForOf, NgIf} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {FormGroup} from "@angular/forms";
import {FormTypes} from "../../../shared/forms/models/constants";
import {SignerModel} from "../../model/signer-model";
import {FileModel} from "../../model/file-model";
import {sign} from "chart.js/helpers";
import {EvidenceSvgPipe} from "../../../shared/pipes/evidence-svg.pipe";

@Component({
    selector: 'app-final-preview',
    standalone: true,
    imports: [
        NgForOf,
        TranslatePipe,
        JsonPipe,
        NgIf,
        EvidenceSvgPipe
    ],
    templateUrl: './final-preview.component.html',
    styleUrl: './final-preview.component.scss'
})
export class FinalPreviewComponent implements OnInit {
    @Input() formGroup!: FormGroup;
    @Input() signerData!: SignerModel;

    @Output() outFormGroup = new EventEmitter();
    protected readonly FormTypes = FormTypes;

    countSignPositions: number = 0;

    ngOnInit() {
        this.countSignPositions = this.signerData?.signpositions?.length
    }

    openBase64File(file: FileModel) {
        const byteCharacters = atob(file.content);
        const byteArrays = [];

        for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
        }

        const byteArray = new Uint8Array(byteArrays);
        const blob = new Blob([byteArray], {type: 'application/pdf'}); // Falls es PDFs sind

        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
    }

    protected readonly sign = sign;
}
